import React from 'react';
import {
  VOLUME_DOT_THRESHOLD_OPTIONS,
  formatVolumeThreshold,
  useBookmapSettingsStore,
} from '../../Store/bookmapSettingsStore';

export default function VolumeBubbleThresholdSelect({ className = '' }) {
  const volumeDotMinVolume = useBookmapSettingsStore((state) => state.volumeDotMinVolume);
  const setVolumeDotMinVolume = useBookmapSettingsStore((state) => state.setVolumeDotMinVolume);

  return (
    <label className={className} title="Minimum gross minute volume for volume bubbles">
      <span>Vol &gt;=</span>
      <select
        aria-label="Volume bubble threshold"
        value={volumeDotMinVolume ?? 'none'}
        onChange={(event) => setVolumeDotMinVolume(event.target.value === 'none' ? null : event.target.value)}
      >
        <option value="none">None</option>
        {VOLUME_DOT_THRESHOLD_OPTIONS.map((threshold) => (
          <option key={threshold} value={threshold}>
            {formatVolumeThreshold(threshold)}
          </option>
        ))}
      </select>
    </label>
  );
}
